/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { customEliteConfigurationControllerCreateConfiguration } from '../fn/custom-elite-configuration/custom-elite-configuration-controller-create-configuration';
import { CustomEliteConfigurationControllerCreateConfiguration$Params } from '../fn/custom-elite-configuration/custom-elite-configuration-controller-create-configuration';
import { customEliteConfigurationControllerDeleteConfiguration } from '../fn/custom-elite-configuration/custom-elite-configuration-controller-delete-configuration';
import { CustomEliteConfigurationControllerDeleteConfiguration$Params } from '../fn/custom-elite-configuration/custom-elite-configuration-controller-delete-configuration';
import { customEliteConfigurationControllerGetConfigurations } from '../fn/custom-elite-configuration/custom-elite-configuration-controller-get-configurations';
import { CustomEliteConfigurationControllerGetConfigurations$Params } from '../fn/custom-elite-configuration/custom-elite-configuration-controller-get-configurations';
import { customEliteConfigurationControllerUpdateConfiguration } from '../fn/custom-elite-configuration/custom-elite-configuration-controller-update-configuration';
import { CustomEliteConfigurationControllerUpdateConfiguration$Params } from '../fn/custom-elite-configuration/custom-elite-configuration-controller-update-configuration';
import { CustomEliteConfigurationModelDto } from '../models/custom-elite-configuration-model-dto';

@Injectable({ providedIn: 'root' })
export class CustomEliteConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `customEliteConfigurationControllerGetConfigurations()` */
  static readonly CustomEliteConfigurationControllerGetConfigurationsPath = '/custom-elite-configuration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customEliteConfigurationControllerGetConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  customEliteConfigurationControllerGetConfigurations$Response(params?: CustomEliteConfigurationControllerGetConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomEliteConfigurationModelDto>>> {
    return customEliteConfigurationControllerGetConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customEliteConfigurationControllerGetConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customEliteConfigurationControllerGetConfigurations(params?: CustomEliteConfigurationControllerGetConfigurations$Params, context?: HttpContext): Observable<Array<CustomEliteConfigurationModelDto>> {
    return this.customEliteConfigurationControllerGetConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomEliteConfigurationModelDto>>): Array<CustomEliteConfigurationModelDto> => r.body)
    );
  }

  /** Path part for operation `customEliteConfigurationControllerCreateConfiguration()` */
  static readonly CustomEliteConfigurationControllerCreateConfigurationPath = '/custom-elite-configuration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customEliteConfigurationControllerCreateConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customEliteConfigurationControllerCreateConfiguration$Response(params: CustomEliteConfigurationControllerCreateConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomEliteConfigurationModelDto>> {
    return customEliteConfigurationControllerCreateConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customEliteConfigurationControllerCreateConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customEliteConfigurationControllerCreateConfiguration(params: CustomEliteConfigurationControllerCreateConfiguration$Params, context?: HttpContext): Observable<CustomEliteConfigurationModelDto> {
    return this.customEliteConfigurationControllerCreateConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomEliteConfigurationModelDto>): CustomEliteConfigurationModelDto => r.body)
    );
  }

  /** Path part for operation `customEliteConfigurationControllerUpdateConfiguration()` */
  static readonly CustomEliteConfigurationControllerUpdateConfigurationPath = '/custom-elite-configuration/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customEliteConfigurationControllerUpdateConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customEliteConfigurationControllerUpdateConfiguration$Response(params: CustomEliteConfigurationControllerUpdateConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomEliteConfigurationModelDto>> {
    return customEliteConfigurationControllerUpdateConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customEliteConfigurationControllerUpdateConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customEliteConfigurationControllerUpdateConfiguration(params: CustomEliteConfigurationControllerUpdateConfiguration$Params, context?: HttpContext): Observable<CustomEliteConfigurationModelDto> {
    return this.customEliteConfigurationControllerUpdateConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomEliteConfigurationModelDto>): CustomEliteConfigurationModelDto => r.body)
    );
  }

  /** Path part for operation `customEliteConfigurationControllerDeleteConfiguration()` */
  static readonly CustomEliteConfigurationControllerDeleteConfigurationPath = '/custom-elite-configuration/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customEliteConfigurationControllerDeleteConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  customEliteConfigurationControllerDeleteConfiguration$Response(params: CustomEliteConfigurationControllerDeleteConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return customEliteConfigurationControllerDeleteConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customEliteConfigurationControllerDeleteConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customEliteConfigurationControllerDeleteConfiguration(params: CustomEliteConfigurationControllerDeleteConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.customEliteConfigurationControllerDeleteConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
